export const HOURLY_FREQUENCY = "HOURLY";
export const DAILY_FREQUENCY = "DAILY";
export const ACTIVE_STATUS = "ACTIVE";
